// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1l3sn","validationTips":"StatementDescriptor_validationTips__11Nmk"};